const createValidation = ( formSelector ) => ({
  isEmptyRequiredField: ( field ) => {
    if (!field.value && (field.hasOwnProperty( 'isRequired' ) ? field.isRequired : true)) {
      $( `${formSelector} .${field.name}-error` ).html( 'This field is required!' ).show();
      return true;
    }
    return false;
  },

  isValidEmail: ( emailField ) => {
    const regExp = /.{2,}@\w+\.\w+/;
    if (!regExp.test( emailField.value )) {
      $( `${formSelector} .${emailField.name}-error` ).html( 'This email address is incorrect!' ).show();
      return false;
    }
    return true;
  },

  isDigitField: ( field ) => {
    const regExp = /^\d+$|^$/;
    if (!regExp.test( field.value )) {
      $( `${formSelector} .${field.name}-error` ).html( 'This field should contain only digits!' ).show();
      return false;
    }
    return true;
  }
});

let timer = 0;

const autocompleteSuburbDropdown = ( dropdownSelector, event ) => {
  const value = $( event.currentTarget ).val();
  clearTimeout( timer );
  timer = setTimeout( () => {
    if (value.length > 1) {
      $.get( `/apincm.php/suburb?suburb=${value}` )
        .done( response => {
          const suburbs = JSON.parse( response );
          $( `${dropdownSelector} .menu` ).html( '' );
          if (response.length > 0) {
            $( `${dropdownSelector} .menu .message` ).hide();
          }
          suburbs.forEach( suburb => {
            $( `${dropdownSelector} .menu` ).append(
              `<div class="item" data-value=${suburb.id}>
                 <span>${suburb.value}</span>
               </div>`
            );
          } );
        } );
    }
  }, 500 );
};

$( document ).ready( function () {
  // Add vehicles to the dropdown
  $.get( '/apincm.php/car-type' )
    .done( response => {
      const carTypes = JSON.parse( response );
      mapIconToCarType( carTypes ).forEach( carType => {
        $( '.vehicles-dropdown .menu' ).append(
          `<div class="item" data-value='${carType.id}'>
              <span data-is-car='${+carType.isCar}'>${carType.description}</span>
              <img src='${carType.icon}'/>
          </div>`
        )
      } );
      $( '.vehicles-dropdown' ).dropdown( 'set selected', carTypes[0].id );
    } );

  // Add car manufacturers to the dropdown
  $.get( '/apincm.php/car-make' )
    .done( response => {
      const carManufacturers = JSON.parse( response );
      carManufacturers.forEach( manufacturer => {
        $( '.manufacturer-dropdown .menu' ).append(
          `<div class="item" data-value=${manufacturer.id}>
               <span>${manufacturer.description}</span>
           </div>`
        );
      } );
    } );

  // Add car models to the dropdown
  $( document ).on( 'change', '.manufacturer-dropdown input', ( event ) => {
    const $modelDropdown = $( event.currentTarget ).parents( 'form' ).find( '.model-dropdown' );
    $modelDropdown.addClass( 'loading' );
    const manufacturerId = $( event.currentTarget ).val();
    $.get( `/apincm.php/car-model?carMakeId=${manufacturerId}` )
      .done( response => {
        const carModels = JSON.parse( response );
        $( '.model-dropdown .menu' ).html( '' );
        $( '.model-dropdown' ).dropdown( 'restore defaults' );
        $modelDropdown.removeClass( 'loading' );
        carModels.forEach( model => {
          $( '.model-dropdown .menu' ).append(
            `<div class="item" data-value=${model.id}>
               <span>${model.description}</span>
           </div>`
          );
        } );
      } )
      .fail( error => $( 'model-error' ).html( error.message ).show() )
  } );

  // The popup form. Submit first step quote
  $( document ).on( 'click', '.quote-form-popup .first-step .button', ( event ) => {
    $( '.quote-form-popup .error-message' ).hide();
    $( '.quote-form-popup .first-step .button' ).attr( 'disabled', true ).addClass( 'disabled' );

    if (+$( '.quote-form-popup .vehicles-dropdown .text span' ).attr( 'data-is-car' )) {
      firstStepQuote( event, '.quote-form-popup', '.quote-form-popup .form-top-part input:not(.search), .quote-form-popup .car-transport-details .form-field:not(.hidden) input:not(.search)' );
    }

    return false;
  } );

  // Submit the popup form
  $( document ).on( 'submit', '.quote-form-popup form', ( event ) => {
    $( '.quote-form-popup .error-message' ).hide();
    $( '.quote-form-popup .second-step .button' ).attr( 'disabled', true ).addClass( 'disabled' );

    if (+$( '.quote-form-popup .vehicles-dropdown .text span' ).attr( 'data-is-car' )) {
      secondStepQuote( event, '.quote-form-popup', '.quote-form-popup .booking-info input' );
    } else {
      nonCarQuoteForm( event, '.quote-form-popup', '.quote-form-popup .form-top-part input:not(.search), .quote-form-popup textarea, .quote-form-popup .non-car-transport-details .form-field:not(.hidden) input:not(.search), .quote-form-popup .booking-info input:not(.hidden)' );
    }

    return false;
  } );

  // Expand the form on the home page
  $( document ).on( 'click', '.expanded-quote', () => {
    let hasError = false;
    $( '.header-quote-form .error-message' ).hide();

    // Getting all the form field values
    const fields = $( '.header-quote-form .form-top-part input:not(.search)' ).map( ( index, input ) => ({
      name: $( input ).attr( 'name' ),
      value: $( input ).val().trim()
    }) ).get();

    const { isEmptyRequiredField } = createValidation( '.header-quote-form' );

    fields.forEach( field => {
      if (isEmptyRequiredField( field )) {
        hasError = true;
      }
    } );

    if (!hasError) {
      $( '.expanded-quote' ).hide();
      $( '.expanded-car-transport-details' ).show();
    }
  } );

  // Submit the first step expandable form
  $( document ).on( 'click', '.quote-form .first-step .button', ( event ) => {
    $( '.quote-form .error-message' ).hide();
    $( '.quote-form .first-step .button' ).attr( 'disabled', true ).addClass( 'disabled' );

    if (+$( '.quote-form .vehicles-dropdown .text span' ).attr( 'data-is-car' )) {
      firstStepQuote( event, '.quote-form', '.quote-form .form-top-part input:not(.search), .quote-form .car-transport-details .form-field:not(.hidden) input:not(.search)' );
    }

    return false;
  } );

  // Submit the expandable form
  $( document ).on( 'submit', '.quote-form form', ( event ) => {
    $( '.quote-form .error-message' ).hide();
    $( '.quote-form .second-step .button' ).attr( 'disabled', true ).addClass( 'disabled' );

    if (+$( '.quote-form .vehicles-dropdown .text span' ).attr( 'data-is-car' )) {
      secondStepQuote( event, '.quote-form', '.quote-form .booking-info input' );
    } else {
      nonCarQuoteForm( event, '.quote-form', '.quote-form .form-top-part input:not(.search), .quote-form textarea, .quote-form .non-car-transport-details .form-field:not(.hidden) input:not(.search), .quote-form .booking-info input:not(.hidden)' );
    }

    return false;
  } );

  // Submit send email form
  $( document ).on( 'submit', '.send-mail-popup form', () => {
    let hasError;
    $( '.send-mail-popup .error-message, .send-mail-popup .success-message' ).hide();
    $( '.send-mail-popup .form-button .button' ).attr( 'disabled', true ).addClass( 'disabled' );

    const emailField = {
      name: $( '.send-mail-popup form input' ).attr( 'name' ),
      value: $( '.send-mail-popup form input' ).val().trim()
    };

    const { isEmptyRequiredField, isValidEmail } = createValidation( '.send-mail-popup' );

    hasError = isEmptyRequiredField( emailField ) || !isValidEmail( emailField );

    if (hasError) {
      event.preventDefault();
      $( '.send-mail-popup .form-button .button' ).attr( 'disabled', false ).removeClass( 'disabled' );
      return false;
    }

    $.post( '/send-quotation-email', { 'Email': emailField.value } )
      .done( response => {
        $( '.send-mail-popup .success-message' ).show();
        $( '.send-mail-popup .form-button .button' ).attr( 'disabled', false ).removeClass( 'disabled' );
      } )
      .fail( jqXHR => {
        const errors = JSON.parse( jqXHR.responseText );
        showFormErrors( errors, '.send-mail-popup' );
      } );

    return false;
  } );

  // Hide error messages after changing the field value
  $( document ).on( 'keyup change', 'input', ( event ) => {
    const errorBlock = $( event.currentTarget ).parents( '.form-field' ).find( '.error-message' );
    if (errorBlock.css( 'display' ) !== 'none') {
      errorBlock.hide();
    }
  } );

  // Autocomplete dropdown
  $( document ).on( 'keyup', '.quote-form-popup .from-suburb-dropdown input.search', ( event ) => {
    autocompleteSuburbDropdown( '.quote-form-popup .from-suburb-dropdown', event );
  } );
  $( document ).on( 'keyup', '.quote-form-popup .to-suburb-dropdown input.search', ( event ) => {
    autocompleteSuburbDropdown( '.quote-form-popup .to-suburb-dropdown', event );
  } );
  $( document ).on( 'keyup', '.right-sidebar .from-suburb-dropdown input.search', ( event ) => {
    autocompleteSuburbDropdown( '.right-sidebar .quote-form .from-suburb-dropdown', event );
  } );
  $( document ).on( 'keyup', '.right-sidebar .to-suburb-dropdown input.search', ( event ) => {
    autocompleteSuburbDropdown( '.right-sidebar .quote-form .to-suburb-dropdown', event );
  } );
  $( document ).on( 'keyup', '.header-quote-form .from-suburb-dropdown input.search', ( event ) => {
    autocompleteSuburbDropdown( '.header-quote-form .from-suburb-dropdown', event );
  } );
  $( document ).on( 'keyup', '.header-quote-form .to-suburb-dropdown input.search', ( event ) => {
    autocompleteSuburbDropdown( '.header-quote-form .to-suburb-dropdown', event );
  } );

  // Move data from the sidebar form to the popup form
  $( document ).on( 'click', '.right-sidebar .quote-form .form-button .button', ( event ) => {
    const vehicleDropdown = $( event.currentTarget ).parents( '.quote-form' ).find( '.vehicles-dropdown' );
    $( '.quote-form-popup .vehicles-dropdown' ).dropdown( 'set selected', vehicleDropdown.find( 'input[type=hidden]' ).val() );

    const fromSuburbDropdown = $( event.currentTarget ).parents( '.quote-form' ).find( '.from-suburb-dropdown' );
    const toSuburbDropdown = $( event.currentTarget ).parents( '.quote-form' ).find( '.to-suburb-dropdown' );

    // Move 'from' field
    $( '.quote-form-popup .from-suburb-dropdown input[type=hidden]' ).val( fromSuburbDropdown.find( 'input[type=hidden]' ).val() );
    const fromSuburb = fromSuburbDropdown.find( '.text' );
    $( '.quote-form-popup .from-suburb-dropdown .text' ).html( fromSuburb.html() );
    if (fromSuburb.hasClass( 'default' )) {
      $( '.quote-form-popup .from-suburb-dropdown .text' ).addClass( 'default' );
    } else {
      $( '.quote-form-popup .from-suburb-dropdown .text' ).removeClass( 'default' );
    }

    // Move 'to' field
    $( '.quote-form-popup .to-suburb-dropdown input[type=hidden]' ).val( toSuburbDropdown.find( 'input[type=hidden]' ).val() );
    const toSuburb = toSuburbDropdown.find( '.text' );
    $( '.quote-form-popup .to-suburb-dropdown .text' ).html( toSuburb.html() );
    if (toSuburb.hasClass( 'default' )) {
      $( '.quote-form-popup .to-suburb-dropdown .text' ).addClass( 'default' );
    } else {
      $( '.quote-form-popup .to-suburb-dropdown .text' ).removeClass( 'default' );
    }

    $( '.quote-form-popup' ).modal( {
      autofocus: false
    } ).modal( 'show' );
  } );

  // Set checkbox value
  $( '.checkbox.custom-toggle-checkbox input' ).val( $( '.checkbox.custom-toggle-checkbox input' ).is( ':checked' ) );
  $( document ).on( 'change', '.checkbox.custom-toggle-checkbox input', ( event ) => {
    $( event.currentTarget ).val( $( event.currentTarget ).is( ':checked' ) );
  } );

  // Switch form according to vehicle type
  $( document ).on( 'change', '.quote-form-popup .vehicles-dropdown input', () => {
    changeQuotationForm( '.quote-form-popup' );
  } );

  // Switch form according to vehicle type
  $( document ).on( 'change', '.quote-form .vehicles-dropdown input', () => {
    changeQuotationForm( '.quote-form' );
  } );

  // Manual quotation
  $( document ).on( 'submit', 'form.manual-quote', () => {
    $( '.manual-quote .form-button .button' ).attr( 'disabled', true ).addClass( 'disabled' );
    $( '.manual-quote .error-message' ).hide();
    let hasError = false;

    const fields = $( '.manual-quote input:not(.hidden)' ).map( ( index, input ) => ({
      name: $( input ).attr( 'name' ),
      value: $( input ).val().trim(),
      isRequired: typeof $( input ).attr( 'data-optional' ) === 'undefined'
    }) ).get();

    const { isEmptyRequiredField, isValidEmail } = createValidation( '.manual-quote' );

    fields.forEach( field => {
      if (field.name.toLowerCase().indexOf( 'email' ) + 1) {
        if (!isValidEmail( field )) {
          hasError = true;
        }
      }
      if (isEmptyRequiredField( field )) {
        hasError = true;
      }
    } );

    //console.log( fields );

    const fieldsObject = fields.reduce( ( result, field ) => ({
      ...result,
      [field.name]: field.value
    }), {} );

    fieldsObject.goods = $( '.manual-quote .add-goods input' ).is( ':checked' );
    fieldsObject.route = $( '.manual-quote .custom-radio.checked input[name=route]' ).val();
    //console.log( fieldsObject );

    if (hasError) {
      event.preventDefault();
      $( '.manual-quote .form-button .button' ).attr( 'disabled', false ).removeClass( 'disabled' );
      return false;
    }

    return false;
  } );
} );